import projectList from './projectList.vue'
import taskList from './taskList.vue'
import taskChildList from './taskChildList.vue'
import tabelList from './tabelList.vue'
import projectTable from './projectTable.vue'
import addProject from './addProject.vue'
import addTask from './addTask.vue'
import addToTask from './addToTask.vue'

export default {
	projectList,
	taskList,
	taskChildList,
	tabelList,
	projectTable,
	addProject,
	addTask,
	addToTask,
}


// WEBPACK FOOTER //
// ./src/components/task/index.js